import Layout from '@/components/feature/Layout';
import SeoHead from '@/components/feature/SeoHead';
import JsonLd from '@/components/feature/JsonLd';
import Hero from '@/pages/home/components/Hero';
import StatsBand from '@/pages/home/components/StatsBand';
import FeaturedActivities from '@/pages/home/components/FeaturedActivities';
import StepsSection from '@/pages/home/components/StepsSection';
import CategoriesSection from '@/pages/home/components/CategoriesSection';
import DrawSection from '@/pages/home/components/DrawSection';
import TaskRulesSection from '@/pages/home/components/TaskRulesSection';
import TestimonialsSection from '@/pages/home/components/TestimonialsSection';
import HomeFaqSection from '@/pages/home/components/HomeFaqSection';
import CtaBand from '@/pages/home/components/CtaBand';
import { faqGroups } from '@/mocks/faq';
import { siteInfo } from '@/mocks/site';

const homeFaqItems = [...faqGroups[1].items.slice(0, 3), ...faqGroups[0].items.slice(0, 2)];

const structuredData = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      name: siteInfo.name,
      alternateName: siteInfo.fullName,
      url: 'https://ikinxod.cn/',
      inLanguage: 'zh-CN',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://ikinxod.cn/activities?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      name: siteInfo.name,
      url: 'https://ikinxod.cn/',
      email: siteInfo.email,
      description: siteInfo.intro,
    },
    {
      '@type': 'WebPage',
      name: '爆瓜福利 - 爆瓜福利活动领取 抽奖任务奖励规则一览',
      description:
        '爆瓜福利汇总最新爆瓜福利活动、抽奖玩法、领取方式与任务奖励规则，帮你快速看懂怎么参与、怎么领奖、怎么拿专属福利。',
      url: 'https://ikinxod.cn/',
      inLanguage: 'zh-CN',
    },
    {
      '@type': 'FAQPage',
      mainEntity: homeFaqItems.map((item) => ({
        '@type': 'Question',
        name: item.q,
        acceptedAnswer: { '@type': 'Answer', text: item.a },
      })),
    },
  ],
};

export default function Home() {
  return (
    <>
      <SeoHead
        path="/"
        title="爆瓜福利 - 爆瓜福利活动领取 抽奖任务奖励规则一览"
        description="爆瓜福利汇总最新爆瓜福利活动、抽奖玩法、领取方式与任务奖励规则，帮你快速看懂怎么参与、怎么领奖、怎么拿专属福利，吃瓜同时轻松领福利。"
        keywords="爆瓜福利,爆瓜福利活动,爆瓜福利抽奖,爆瓜福利领取,爆瓜福利任务,爆瓜福利奖励,爆瓜福利规则"
      />
      <JsonLd data={structuredData} />
      <Layout>
        <Hero />
        <StatsBand />
        <FeaturedActivities />
        <StepsSection />
        <CategoriesSection />
        <DrawSection />
        <TaskRulesSection />
        <TestimonialsSection />
        <HomeFaqSection />
        <CtaBand />
      </Layout>
    </>
  );
}